import { Navigate, RouteObject } from "react-router-dom";

import { EXPERIMENT_ROUTES, GENERAL_ROUTES } from "@src/routes/routes";

export const MobileAnalyticsRoutes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to={EXPERIMENT_ROUTES.Experiments} replace />,
  },
  {
    path: GENERAL_ROUTES.LegacySitewideAnalyticsHolidayBenchmark_Id,
    lazy: async () => {
      const { HolidayTrackerLegacyRedirect } =
        await import("@src/features/analytics/sitewideAnalytics/routes/HolidayTrackerLegacyRedirect");
      return { Component: HolidayTrackerLegacyRedirect };
    },
  },
  {
    path: GENERAL_ROUTES.SitewideAnalyticsHolidayTracking_Id,
    lazy: async () => {
      const { MobileHolidayBenchmarking } =
        await import("@src/features/mobileAnalytics/holidayBenchmarking");
      return { Component: MobileHolidayBenchmarking };
    },
  },
  {
    path: EXPERIMENT_ROUTES.Experiments,
    lazy: async () => {
      const { MobileTestList } =
        await import("@src/features/mobileAnalytics/testList/MobileTestList");
      return { Component: MobileTestList };
    },
  },
  {
    path: EXPERIMENT_ROUTES.Experiment_Id,
    lazy: async () => {
      const { MobileTestDetails } =
        await import("@src/features/mobileAnalytics/testDetails/MobileTestDetails");
      return { Component: MobileTestDetails };
    },
  },
  {
    path: GENERAL_ROUTES.GetInspired,
    lazy: async () => {
      const { MobileGetInspired } =
        await import("@src/features/mobileAnalytics/getInspired/MobileGetInspired");
      return { Component: MobileGetInspired };
    },
  },
  {
    path: GENERAL_ROUTES.GetInspiredPageById,
    lazy: async () => {
      const { MobileGitBookViewer } =
        await import("@src/features/mobileAnalytics/getInspired/MobileGitBookViewer");
      return { Component: MobileGitBookViewer };
    },
  },
  {
    path: GENERAL_ROUTES.GetInspiredYouTube,
    lazy: async () => {
      const { MobileYouTubeViewer } =
        await import("@src/features/mobileAnalytics/getInspired/MobileYouTubeViewer");
      return { Component: MobileYouTubeViewer };
    },
  },
  {
    path: GENERAL_ROUTES.GetInspiredDoc,
    lazy: async () => {
      const { MobileGitBookViewer } =
        await import("@src/features/mobileAnalytics/getInspired/MobileGitBookViewer");
      return { Component: MobileGitBookViewer };
    },
  },
  {
    path: "/*",
    lazy: async () => {
      const { MobileWildcardPage } =
        await import("@src/features/mobileAnalytics/MobileWildcardPage");
      return { Component: MobileWildcardPage };
    },
  },
];
